<template lang="pug">
  .panel-page-white.mx-auto.body-1
    .panel
      PageHeader Dashboard Settings
      form(
        @submit.prevent="saveAnnouncement"
        autocomplete="off"
      )
        .form-row.mt-3
          .col
            h2 Announcements
        .form-row.mt-2
          .col
            h5 Current Announcement
            a(href="" @click.prevent="edit") Edit
        .form-row.mt-2
          .col-8
            div.curr-announcement
              p
                strong {{ currentAnnouncement[0] }}
              p(v-html="currentAnnouncement[1]")
        .form-row.mt-2(v-show="showEdit")
          .col-8
            label(for="announcements") New Announcement
            textarea#announcements.form-control(
              v-model="newAnnouncement"
            )
        .form-row.mt-2
          .col
            button.btn.btn-primary.mr-3(type="submit" :disabled="!showEdit") Save
            router-link.btn.btn-light(:to="{name: 'dashboard'}") Cancel
</template>

<script>
import PageHeader from '@/components/PageHeader'
import { mapState } from 'vuex'

export default {
  name: 'DashboardSettings',
  data() {
    return {
      newAnnouncement: '',
      showEdit: false,
    }
  },
  methods: {
    edit() {
      this.newAnnouncement = this.currentAnnouncement[1]
      this.showEdit = true
    },
    saveAnnouncement() {
      this.$store.dispatch('saveNewAnnouncement', this.newAnnouncement)
      this.$router.push({ name: 'dashboard' })
    },
  },
  computed: {
    ...mapState({
      currentAnnouncement: 'announcement',
    }),
  },
  components: { PageHeader },
}
</script>

<style lang="scss" scoped>
.curr-announcement {
  padding: 0.6rem;
  border: 2px solid lightgray;
}
</style>
